import React from 'react';
import styled from 'styled-components';

const Header = styled.div`
  width: 100%;
  height: 80px;
  border-bottom: 1px solid rgba(130, 147, 164, 0.4);
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: ${(props) => props.theme.colors.elephant};
  display: flex;
  align-items: center;
  padding: 0 0 0 40px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 0 0 0 20px;
    line-height: 19px;
    height: 50px;
  }
`;

const ModalHeader: React.FunctionComponent<IProps> = ({
  children,
  className,
}) => {
  return <Header className={className}>{children}</Header>;
};

export default ModalHeader;

interface IProps {
  children: React.ReactNode;
  className?: string;
}
